import React from 'react';
import { motion } from 'framer-motion';

const ThankYouProgress = () => {
  return (
    <div className="bg-white border border-stone-200 p-8 rounded-[2rem] shadow-sm mb-12">
      <div className="flex justify-between items-end mb-4">
        <span className="text-[10px] font-black uppercase tracking-[0.2em] text-amber-800">Status do Cadastro</span>
        <span className="text-2xl font-black text-stone-900 tracking-tighter">75% concluído</span>
      </div>
      
      <div className="h-4 w-full bg-stone-100 rounded-full overflow-hidden p-1 shadow-inner">
        <motion.div 
          initial={{ width: 0 }}
          animate={{ width: '75%' }}
          transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1], delay: 0.5 }}
          className="h-full bg-gradient-to-r from-amber-600 to-amber-800 rounded-full relative"
        >
          <div className="absolute inset-0 bg-white/20 animate-pulse" />
        </motion.div>
      </div>
      
      <p className="text-stone-500 text-xs mt-4 italic font-medium">
        Falta apenas a confirmação final via WhatsApp para liberar sua vaga.
      </p>
    </div>
  );
};

export default ThankYouProgress;